import { APIProvider, Map, Marker, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState, useRef } from "react";
import { Location } from "./LiveLocation";

type Props = {
  myLocation: Location | null;
  otherLocation?: Location | null;
  mylocationimg?: string |  null
  otherlocationimg?: string | null
};

const googlePlacesApiKey = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;

function DirectionsRenderer({ origin, destination }: { origin: Location; destination: Location }) {
  const map = useMap();
  const routesLibrary = useMapsLibrary("routes");
  const directionsRendererRef = useRef<google.maps.DirectionsRenderer | null>(null);
  const [apiError, setApiError] = useState<string | null>(null);

  useEffect(() => {
    if (!map || !origin || !destination) return;

    const initializeDirections = async () => {
      try {
        // Clear previous renderer if it exists
        if (directionsRendererRef.current) {
          directionsRendererRef.current.setMap(null);
          directionsRendererRef.current = null;
        }

        // // Try the new Routes API if available
        // if (routesLibrary?.Route) {
        //   const route = new routesLibrary.Route({
        //     map,
        //     travelMode: "DRIVE",
        //   });

        //   await route.route({
        //     origin: { lat: origin.lat, lng: origin.lng },
        //     destination: { lat: destination.lat, lng: destination.lng }
        //   });
        //   setApiError(null);
        //   return;
        // }

        // Fallback to classic Directions Service
        if (window.google?.maps?.DirectionsService) {
          const directionsService = new google.maps.DirectionsService();
          const directionsRenderer = new google.maps.DirectionsRenderer({
            map,
            suppressMarkers: true,
            polylineOptions: {
              strokeColor: "#4285F4",
              strokeOpacity: 0.8,
              strokeWeight: 5,
            },
          });

          directionsRendererRef.current = directionsRenderer;

          directionsService.route(
            {
              origin: { lat: origin.lat, lng: origin.lng },
              destination: { lat: destination.lat, lng: destination.lng },
              travelMode: google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === "OK" && result) {
                directionsRenderer.setDirections(result);
                setApiError(null);
              } else {
                setApiError(`Directions failed: ${status}`);
              }
            }
          );
        } else {
          setApiError("No available directions API");
        }
      } catch (error) {
        console.error("Directions initialization failed:", error);
        setApiError("Failed to load directions");
      }
    };

    initializeDirections();

    return () => {
      // Clean up on unmount
      if (directionsRendererRef.current) {
        directionsRendererRef.current.setMap(null);
      }
    };
  }, [map, routesLibrary, origin, destination]);

  return null;
}

export default function LiveMap({ myLocation,mylocationimg,otherlocationimg, otherLocation }: Props) {
  const [mapCenter, setMapCenter] = useState<Location | undefined>();
  const mapsLib = useMapsLibrary("maps");
  console.log("img url",mylocationimg)
  console.log("otherlocation",otherlocationimg)
  useEffect(() => {
    if (myLocation && otherLocation) {
      setMapCenter({
        lat: (myLocation.lat + otherLocation.lat) / 2,
        lng: (myLocation.lng + otherLocation.lng) / 2
      });
    } else if (myLocation) {
      setMapCenter(myLocation);
    } else if (otherLocation) {
      setMapCenter(otherLocation);
    }
  }, [myLocation, otherLocation]);

  return (
    <div style={{ height: "70vh", width: "100%" }}>
      <APIProvider 
        apiKey={googlePlacesApiKey || ""}
        libraries={["routes", "marker"]}
      >
        <Map 
          defaultCenter={mapCenter}
          defaultZoom={14}
          zoomControl={true}
          gestureHandling={"greedy"}
        >
      {myLocation && (
  <Marker 
    position={myLocation}
    title={"Your Location"}
    icon={mylocationimg ? {
      url: mylocationimg,
      // scaledSize: new google.maps.Size(40, 40), // Use global google.maps
    } : undefined} // Fallback to default marker if no image
  />
)}

{otherLocation && (
  <Marker 
    position={otherLocation}
    title={"Professional Location"}
    icon={otherlocationimg ? {
      url: otherlocationimg,
      // scaledSize: new google.maps.Size(40, 40), // Use global google.maps
    } : undefined} // Fallback to default marker if no image
  />
)}

          
          {myLocation && otherLocation && (
            <DirectionsRenderer 
              origin={myLocation}
              destination={otherLocation}
            />
          )}
        </Map>
      </APIProvider>
    </div>
  );
}